import { hexToRgb } from './hexToRgb';

// perceived brightness - https://www.w3.org/TR/AERT/#color-contrast
export function isBrightColor(color: string) {
  const [r, g, b] = hexToRgb(color);
  return r * 0.299 + g * 0.587 + b * 0.114 > 200;
}
